"use client"

import styled from "@emotion/styled"
import { useState } from "react"
import { NewText } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import GeneralPositionModal from "./GeneralPositionModal"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-top: 24px;
  width: 100%;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
  max-width: 624px;
`

const StyledButton = styled.button`
  background-color: ${sharedColors.blue4rentMarketing};
  color: ${sharedColors.white};
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  width: 328px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  font-family: "NarkissBlock", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  
  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${sharedColors.darkBlue};
    outline-offset: 2px;
  }
`

const StyledTitle = styled(NewText)`
    text-align: center;
    line-height: 26px !important;
    letter-spacing: 0;

    ${(props) => props.theme.breakpoints.up("md")} {
        line-height: 36px !important;
        letter-spacing: -0.48px;
    }
`

const StyledDescription = styled(NewText)`
    text-align: center;
    white-space: pre-wrap;
    line-height: 23.2px !important;

    ${(props) => props.theme.breakpoints.up("md")} {
        line-height: 27px !important; 
        letter-spacing: -0.36px;
    }
`

type Props = {
    data?: any
}

export const NoJobsFound = ({ data }: Props) => {
    const title = extractProperty(data, "title")
    const text = extractProperty(data, "text")
    const button = extractProperty(data, "button")
    const buttonData = button?.[0]
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <Container role="status" aria-live="polite">
            <TextContainer>
                {title && (
                    <StyledTitle
                        component="h3"
                        desktopFontSize={24}
                        mobileFontSize={20}
                        color={sharedColors.black}
                        desktopFontWeight={700}
                    >
                        {title}
                    </StyledTitle>
                )}
                {text && (
                    <StyledDescription
                        component="p"
                        desktopFontSize={18}
                        mobileFontSize={16}
                        color={sharedColors.black}
                        desktopFontWeight={400}
                    >
                        {text}
                    </StyledDescription>
                )}
            </TextContainer>
            {buttonData && (
                <StyledButton type="button" onClick={() => setIsModalOpen(true)} aria-label={buttonData?.name}>
                    {buttonData?.name}
                </StyledButton>
            )}
            <GeneralPositionModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </Container>
    )
}
